/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import React from 'react';
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {ReactComponent as Lock} from "../../assets/img/icons/lock-line.svg";

const CheckoutHeadLabels = (props) => {

    const { t, i18n } = useTranslation();

    return (
        <div className='checkoutBox__header'>
            <div className='checkoutBox__num'>{props.num}</div>
            <div className='checkoutBox__title'>{props.title}</div>
            {props.lock && <div className='checkoutBox__link'>{t('checkout.secureCheckout')} <Lock/></div>}
            {props.account && <div className='checkoutBox__link'> <Link to={`/${i18n.language}/login`}>{t('register.registerAlready')}</Link></div>}
        </div>
    );
};

export default CheckoutHeadLabels;

CheckoutHeadLabels.defaultProps = {
    account: false,
    lock: false
};